const swimWomen = [
  { title: "Bikinis", icon: "icon2", subcategories: [] },
  { title: "One Pieces", icon: "icon2", subcategories: [] },
  { title: "Cover-Ups", icon: "icon2", subcategories: [] },
];
export default swimWomen;
